module.exports = __webpack_public_path__ + "static/media/posicionamento.736a97d6.png";